import { render, staticRenderFns } from "./TicketTrends.vue?vue&type=template&id=0a9d9cd0&scoped=true&"
import script from "./TicketTrends.vue?vue&type=script&lang=js&"
export * from "./TicketTrends.vue?vue&type=script&lang=js&"
import style0 from "./TicketTrends.vue?vue&type=style&index=0&id=0a9d9cd0&lang=scss&scoped=true&"
import style1 from "./TicketTrends.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9d9cd0",
  null
  
)

export default component.exports